/**
 * Обивка выбранного предмета мягкой мебели: что за предмет, какая ткань на нём сейчас и
 * «Своя» — вернуть обивку, с которой пришла модель. Стоит над каталогом тканей.
 */
import { useProjectStore } from "@/shared/store";
import { floorItemOwner } from "@/shared/store/layers/floorItemsStore";
import { UIKit } from "@/shared/ui";
import { useEditorStore } from "@/widgets/editor";
import type { FabricTarget } from "../hooks/useFabricTarget";

export const FabricTargetCard = ({ target }: { target: FabricTarget }) => {
	const isReadOnly = useEditorStore((s) => s.isReadOnly);
	const { item, info, fabric } = target;

	const resetFabric = () => {
		const owner = floorItemOwner(item.id);
		if (!owner) return;
		// Своя обивка — тоже шаг истории: Ctrl+Z вернёт ткань
		useProjectStore
			.getState()
			.recordEdit(() => owner.getState().updateFloorItem(item.id, { fabric: undefined }));
	};

	return (
		<div className="flex items-center gap-2.5 p-3">
			<UIKit.Text
				as="span"
				className="size-10 shrink-0 overflow-hidden rounded-md border border-border bg-surface-subtle"
				style={{ backgroundColor: fabric?.color ?? info.color }}
			>
				{fabric && <img src={fabric.thumb} alt="" className="size-full object-cover" />}
			</UIKit.Text>
			<div className="min-w-0 flex-1">
				<UIKit.Text className="truncate text-xs text-muted">
					Обивка · {info.name}
					{fabric ? ` · ${fabric.collection}` : ""}
				</UIKit.Text>
				<UIKit.Text className="truncate text-sm font-semibold text-ink">
					{fabric?.name ?? "Своя обивка модели"}
				</UIKit.Text>
			</div>
			{fabric && !isReadOnly && (
				<button
					type="button"
					title="Вернуть обивку, с которой пришла модель"
					className="shrink-0 rounded-md border border-border bg-surface px-2 py-1 text-xs text-ink hover:bg-surface-hover"
					onClick={resetFabric}
				>
					Своя
				</button>
			)}
		</div>
	);
};
